$(document).ready(function () {

  let formErrorMsgJSON = {};

  if (formErrorMsg) {
    formErrorMsgJSON = JSON.parse(formErrorMsg);
  }

  if (Object.keys(formErrorMsgJSON).length > 0) {

    Swal.fire({
      icon: 'error',
      title: 'Błąd walidacji danych!',
      text: 'Sprawdź czy wszystkie dane są poprawne. Jeśli błąd będzie się powtarzał, skontaktuj się z nami.',
    });

    formErrorMsgJSON = JSON.parse(formErrorMsg);

    $('.error-message').remove();

    for (let sectionKey in formErrorMsgJSON) {
      if (formErrorMsgJSON.hasOwnProperty(sectionKey)) {
        let sectionData = formErrorMsgJSON[sectionKey];
        if (typeof sectionData === 'object') {

          for (let fieldKey in sectionData) {
            let errorMessage = sectionData[fieldKey];

            if (sectionKey === 'name') {
              $(document).find('input[' + sectionKey + '="' + fieldKey + '"]').after('<p class="error-message-input">' + errorMessage + '</p>');
            }

            $(document).find(sectionKey + fieldKey).after('<p class="error-message-after-post">' + errorMessage + '</p>');
          }
        }
      }
    }
  }
});

//FORMULARZY:

// LICZY KROKI - ZAGŁÓWKI H2 W FORMULARZACH WYDARZENIE / MIEJSCE I DODAJE NÓMER KROKU
window.onload = function () {
  var form = document.querySelector("[data-aplication-form]");

  if (form) {
    var formAllTitles = form.getElementsByTagName("h2");

    for (var i = 0; i < formAllTitles.length; i++) {
      var formTitle = formAllTitles[i];
      var formTitleStep = formTitle.querySelector(".goStep");
      if (formTitleStep === null) continue;
      var formTitleText = formTitleStep.innerHTML;
      formTitleStep.innerHTML = i + 1 + " " + formTitleText;
    }
  }

  // USUWA CLASS "hidden-xs JESLI GALERIJA POSIADA 4 PHOTO
  let galleryList = $("#galleryList li").length;

  if ((galleryList == 4) && (window.innerWidth < 991)) {
    $("#galleryList li").removeClass("hidden-xs");
  }
  let checkDateBtn = $(document).find("#anchorCheckTherm").length;
  // console.log(checkDateBtn);

  if (checkDateBtn === 0) {
    $(document).find(".sharePostBox ").addClass("xD");
  }
};

function select2PlacesHintsDestroy(itemClass) {
  $(itemClass).select2('destroy');
}

function select2PlacesHints(itemClass) {
  $(itemClass).select2({
    width: '100%',
    closeOnSelect: true,
    placeholder: 'Miejsce *',
    minimumInputLength: 3,
    tags: true,

    createTag: function (params) {

      let term = $.trim(params.term);

      if (term === '') {
        return null;
      }

      return {
        id: term,
        text: term,
        newTag: true,
      }

    },

    language: {
      inputTooShort: function (args) {
        return 'Wpisz minimum 3 znaki aby rozpocząć wyszukiwanie.';
      },
      searching: function () {
        return "Szukam...";
      },
      noResults: function () {
        return "Brak wyników.";
      },
    },

    formatInputTooShort: 'Wprowadź minimum 3 znaki aby rozpocząć wyszukiwanie.',

    ajax: {

      url: "places-hints",
      dataType: 'json',
      delay: 500,

      data: function (query) { return query; },

      processResults: function (data) {
        let results = [];
        data.forEach(e => { results.push({ id: e.id, text: e.text }); });
        return { results: results };
      },
    },

    templateResult: formatResult

  });

  function formatResult(d) {
    if (d.loading) { return d.text; }
    return $('<option/>').attr({ 'value': d.value }).text(d.text);
  }

  // Dodanie inputa typu hidden który przesyła zawartość selecta do formularza
  $(document).on('select2:select', itemClass, function (e) {
    const selectedOption = $(this).find('option:selected');
    const selectedText = selectedOption.text();
    const selectedId = selectedOption.val();
    const placeKeeperInput = $(this).parent().parent().find('.placeKeeper');
    const disabledInput = $('<input>').attr({
      type: 'hidden',
      name: 'eventPlace[' + selectedId + '][place]',
      class: 'inputTextEach inputText placeKeeper',
      value: selectedText
    });



    const currOptionName = $(selectedOption).parent().attr('name');
    const currOptionId = currOptionName.match(/\d{1}/)[0];

    const isCustomPlace = isNaN(selectedId);
    const customAddressInputId = 'customAddressInput_' + currOptionId;
    const customAddressInputName = 'eventPlace[' + selectedId + '][customAddress]';
    const customAddressNotificationId = 'customAddressNotification_' + currOptionId;

    if (isCustomPlace) {

      const customAddressNotification = $('<span>Tego miejsca nie ma jeszcze w naszej bazie. Podaj jego pełny adres abyśmy mogli je wprowadzić.</span>').attr({
        class: 'customAddressNotification',
        id: customAddressNotificationId,
      });

      const customAddressInput = $('<input>').attr({
        type: 'text',
        required: true,
        name: customAddressInputName,
        class: 'inputTextEach inputText customAddress',
        id: customAddressInputId,
        value: '',
        placeholder: 'Ulica i nr budynku, kod pocztowy, miasto'
      });

      $(this).parent().after(customAddressNotification);
      $(customAddressNotification).after(customAddressInput);

      $('input[name="' + customAddressInputName + '"]').each(function (index) {
        if (index > 0) $(this).remove();
      });

      $('span[id="' + customAddressNotificationId + '"]').each(function (index) {
        if (index > 0) $(this).remove();
      });


    } else {
      $('#' + customAddressInputId).remove();
      $('#' + customAddressNotificationId).remove();
    }



    // Sprawdzenie i usunięcie inputa dodanego w twigu
    if (placeKeeperInput.val()) {
      placeKeeperInput.remove();
    }

    $(this).parent().after(disabledInput);


  });


  $(document).on('select2:open', () => {
    document.querySelector('.select2-search__field').focus();
  });
}

// KROK 2 - DODAJ TERMINY / BILETY NA PIERWSZE ZAŁADOWANIE
$(".selectEventTerminType").bind("change", function (e) {
  if (e.target.value === "Timestamp") {

    $(this).parent().parent().find("#dateFromEvent").removeAttr('disabled').attr('data-parsley-required', true);
    $(this).parent().parent().find("#dateToEvent").prop('disabled', true).removeAttr('data-parsley-required').removeClass('parsley-error').val('');
    // $(selectsConitanerNewClass).parent().find(".parsley-errors-list").attr('aria-hidden',true).empty();

  } else if (e.target.value === "Unbounded") {

    $(this).parent().parent().find("#dateFromEvent").prop('disabled', true).removeAttr('data-parsley-required').removeClass('parsley-error').val('');
    $(this).parent().parent().find("#dateToEvent").prop('disabled', true).removeAttr('data-parsley-required').removeClass('parsley-error').val('');

    $(this).parent().parent().find(".parsley-errors-list").remove();

  } else if (e.target.value === "Period") {

    $(this).parent().parent().find("#dateFromEvent").removeAttr('disabled').attr('data-parsley-required', true);
    $(this).parent().parent().find("#dateToEvent").removeAttr('disabled').attr('data-parsley-required', true);

  } else {

    $(this).parent().parent().find("#dateFromEvent").removeAttr('disabled');
    $(this).parent().parent().find("#dateToEvent").removeAttr('disabled');

  }

});

$(".selectEventEntry").bind("change", function (e) {
  if (e.target.value === "Free") {
    $(this).parent().parent().find("#priceFromEvent").prop('disabled', true).removeAttr('data-parsley-required').removeClass('parsley-error').val('');
    $(this).parent().parent().find("#priceToEvent").prop('disabled', true).removeAttr('data-parsley-required').removeClass('parsley-error').val('');
    $(this).parent().parent().find(".parsley-errors-list").attr('aria-hidden', true).empty();
  } else {
    $(this).parent().parent().find("#priceFromEvent").removeAttr('disabled');
    $(this).parent().parent().find("#priceToEvent").removeAttr('disabled');
  }
});

// KLIK NA BUTTON "DODAJ NOWE MIEJSCE" DODAJE POLA DO MEJSCA, MAX 3
$(function () {
  const addButton = document.querySelector(".addPlaceEvent");
  if (addButton) {

    let fieldsCounter = 0;

    addButton.addEventListener("click", function () {
      event.preventDefault();

      const itemSection = document.querySelector(
        ".eventsAddSectionFields"
      );

      const itemListCount = document.querySelectorAll(
        ".eventsAddSectionFields"
      ).length;

      if (itemListCount >= 10) {
        addButton.disabled = true;
        addButton.style.backgroundColor = "blue";
        return;
      }

      const clonedItemSection = itemSection.cloneNode(true);
      $(clonedItemSection).find('.placeKeeper').remove();
      $(clonedItemSection).find('.customAddress').remove();
      //Usunięcie errorów z daty jeżeli takie są.
      $(clonedItemSection).find('.parsley-required').remove();
      $(clonedItemSection).find('.error-date').remove();
      $(clonedItemSection).find('.customAddressNotification').remove();
      $(clonedItemSection).find('input[type=datetime-local]').removeClass('parsley-error').addClass('parsley-success')

      let stringId = itemListCount.toString();
      $(clonedItemSection).each(function () {

        let inputs = $(this).find('.inputTextEach');
        $(this).addClass('eventsAddSectionFields_' + stringId).prepend('<button class="remove-event-place" id="remove-event-place" aria-label="Usuń pole wydarzenia"><span class="icon icon-close" aria-hidden="true"></span></button>');

        $(inputs).each(function () {

          let name = $(this).attr('name');
          name = name.replace(/\d{1}/, itemListCount);
          $(this).attr('name', name);

          if ($(this).is('select') === false) {
            $(this).val('');
            $(this).removeAttr('disabled');
          }

          if ($(this).is('select')) {
            if ($(this).hasClass('selectEventTerminType')) {
              $(this).addClass('selectEventTerminType_' + stringId);
            }

            if ($(this).hasClass('selectEventEntry')) {
              $(this).addClass('selectEventEntry_' + stringId);
            }
          }
        });

        $(this).find('.applicationSection__place').empty();
        let htmlTemplate = $('<select name="event[' + stringId + '][placeEvent]" class="inputTextEach inputText js-data-example-ajax" id="inputTextEach_' + stringId + '" aria-label="Wybierz typ wstępu na wydarzenie" data-select-event-form="" tabindex="0" aria-hidden="false" data-parsley-required="true"><option></option></select>');
        $(this).find('.applicationSection__place').html(htmlTemplate);

      });

      let selectNewId = '#inputTextEach_' + stringId;
      let selectsConitanerNewClass = '.eventsAddSectionFields_' + stringId

      let selectTerminNewClass = '.selectEventTerminType_' + stringId;
      let selectEntryNewClass = '.selectEventEntry_' + stringId;

      let timeout = setTimeout(() => {

        select2PlacesHints(selectNewId);

        // KROK 2 - DODAJ TERMINY / BILETY NA DYNAMICZNIE DODANE POLA
        $(selectTerminNewClass).bind("change", function (e) {

          $(this).parent().parent().parent().parent().find('.error-date').remove();
          if (e.target.value === "Timestamp") {
            $(this).parent().parent().find('.dateFromEvent').prop('disabled', false).attr('data-parsley-required', true).removeClass('parsley-error').val('');
            $(this).parent().parent().find('.dateToEvent').prop('disabled', true).removeAttr('data-parsley-required').removeClass('parsley-error').val('');
            $(selectsConitanerNewClass).parent().find(".parsley-errors-list").attr('aria-hidden', true).empty();

          } else if (e.target.value === "Unbounded") {
            $(this).parent().parent().find('.dateFromEvent').prop('disabled', true).removeAttr('data-parsley-required').removeClass('parsley-error').val('');
            $(this).parent().parent().find('.dateToEvent').prop('disabled', true).removeAttr('data-parsley-required').removeClass('parsley-error').val('');
            $(selectsConitanerNewClass).find('.parsley-errors-list').prop('disabled', true).remove();

          } else if (e.target.value === "Period") {
            $(this).parent().parent().find('.dateFromEvent').removeAttr('disabled').removeClass('parsley-error').val('');
            $(this).parent().parent().find('.dateToEvent').removeAttr('disabled').removeClass('parsley-error').val('');

            $(this).parent().parent().find('.dateFromEvent').attr('data-parsley-required', true).val('');
            $(this).parent().parent().find('.dateToEvent').attr('data-parsley-required', true).val('');



          }
        });

        $(selectEntryNewClass).bind("change", function (e) {
          if (e.target.value === "Free") {
            $(this).parent().parent().find("#priceFromEvent").prop('disabled', true).removeAttr('data-parsley-required').removeClass('parsley-error').val('');
            $(this).parent().parent().find("#priceToEvent").prop('disabled', true).removeAttr('data-parsley-required').removeClass('parsley-error').val('');
            $(selectsConitanerNewClass).parent().find(".parsley-errors-list").attr('aria-hidden', true).empty();
          } else {
            $(this).parent().parent().find(".priceFromEvent").removeAttr('disabled');
            $(this).parent().parent().find(".priceToEvent").removeAttr('disabled');
          }
        });
      }, 10);

      const parent = document.querySelector(".termsItem--info").parentNode;

      parent.insertBefore(
        clonedItemSection,
        document.querySelector(".termsItem--info")
      );

      if (itemListCount + 1 === 10) {
        addButton.disabled = true;
        addButton.style.opacity = "0.3";
      }
    });
  }
});


//Button usuwający pole z eventem
$(document).on("click", ".remove-event-place", function (e) {
  e.preventDefault();
  $(this).parent().remove();
  const itemListCount = document.querySelectorAll(
    ".eventsAddSectionFields"
  ).length;
  const addButton = document.querySelector(".addPlaceEvent");

  if (itemListCount < 3) {
    addButton.disabled = false;
    addButton.backgroundColor = '#697681';
    addButton.style.opacity = "1.0";
  }
});
// KROK 5 - WALIDACJA POLA TELEFON / FACEBOCK / INSTAGRAM / YOUTUBE
$(function () {
  /* Uwaga: należy pamiętać, że wzorce regularne są jedynie narzędziem do walidacji
  i nie gwarantują w 100% poprawności adresu URL.
  W przypadku walidacji adresów URL zawsze istnieje ryzyko, że dopuszczalne
  adresy URL zostaną odrzucone lub nieprawidłowe adresy URL zostaną zaakceptowane. */

  // document.addEventListener("DOMContentLoaded", function () {
  //   const phoneInput = document.getElementById("contactPhoneEvent");
  //   if (phoneInput) {
  //     phoneInput.pattern = "[0-9]{3}-[0-9]{3}-[0-9]{4}";
  //   }
  // });

  const facebookInput = document.getElementById("facebookEvent");
  if (facebookInput) {
    facebookInput.pattern = new RegExp(
      "http://www\\.facebook\\.com\\/(.+)|https://www\\.facebook\\.com\\/(.+)"
    );
  }

  const instagramInput = document.getElementById("instagramEvent");
  if (instagramInput) {
    instagramInput.pattern = new RegExp(
      "^https?:\\/\\/(www\\.)?instagram\\.com\\/.+"
    );
  }

  const youtubeInput = document.getElementById("youtubeEvent");
  if (youtubeInput) {
    youtubeInput.pattern = new RegExp(
      "^((http|https):\\/\\/)?(www\\.)?youtube\\.com\\/(channel\\/[-a-zA-Z0-9_]+|user\\/[-a-zA-Z0-9_]+|c\\/[-a-zA-Z0-9_]+|watch\\?v=[a-zA-Z0-9_\\-]+&?(.+)?|embed\\/[-a-zA-Z0-9_]+|playlist\\?list=[a-zA-Z0-9_\\-]+&?(.+)?|@([a-zA-Z0-9_\\-]+)\\/?)S*"
    );
  }
});


/* POLE IMG:
- MAX ILOSĆ PHOTO = 20
- WALIDNE FORMATY = jpeg, jpg, png
- MAX ROZMIAR JEDNEGO PHOTO = 2 M */

// TODO ZAKOMENTOWAĆ TĄ FUNKCIJE W RAZIE, JESLI PRZYWRACAMY BIBLIOTEKĘ DROPZONE
$(function () {
  const input = document.getElementById("addPhotoEvent");
  if (input) {
    input.addEventListener("change", () => {
      if (!validateAndUploadImage(input)) {
        return;
      }
    });
  }

  const form = $("[data-application-form]");
  if (form.length > 0) {
    form.addEventListener("submit", (event) => {
      event.preventDefault();
      if (validateAndUploadImage(input) && validateForm()) {
        submitForm();
      }
    });
  }

  function validateAndUploadImage(input) {
    const allowedExtensions = /(\.jpg|\.jpeg|\.png)$/i;
    const maxFileSize = 2 * 1024 * 1024;
    const maxNumberOfImages = 20;

    if (input.files.length > maxNumberOfImages) {
      Swal.fire({
        icon: "error",
        title: "Możesz dodać maksymalnie " + maxNumberOfImages + " obrazków."
      });
      input.value = "";
      return false;
    }

    for (let i = 0; i < input.files.length; i++) {
      const file = input.files[i];

      if (!allowedExtensions.exec(file.name)) {
        Swal.fire({
          icon: "error",
          title: "Dopuszczalne formaty plików tylko: JPEG, JPG, PNG."
        });
        input.value = "";
        return false;
      }
      if (file.size > maxFileSize) {
        Swal.fire({
          icon: "error",
          title: "Maksymalny rozmiar każdego obrazka to 2MB."
        });
        input.value = "";
        return false;
      }
    }
    return true;
  }

  function validateForm() {
  }

  function submitForm() {
  }

});

// KROK 4 OKREŚL KATEGORIE OBIEKTU
$(document).ready(function () {
  $('#select_mainNewCategoryId\\[mainCategoryId\\]').change(function () {
    var selectedCategory = $(this).val();

    $('.select-category-offer').addClass('loading');

    renderList(selectedCategory);
  });

  function renderList(categoryNumber) {

    let type = 'offers'
    if ($('.applicationSection__form').hasClass("addPlaceForm")) type = 'places';
    let requireCheckboxes = '';
    if (type === 'offers') {
      requireCheckboxes = 'data-parsley-multiple="multiple"';
    }
    var url = `get-subcategories?type=${type}&subcategoryId=${categoryNumber}`;
    var $listComponent = $('#object_listCategory');

    $.ajax({
      url: url,
      dataType: "json",
      success: function (data) {

        $listComponent.empty();

        data.forEach(function (item) {
          $listComponent.append(`
            <li class="applicationSection__categoryItem">
              <label>
                <input 
                  type="checkbox" 
                  name="mainNewCategoryId[newCategoriesIds][]" 
                  value="${item.id}" 
                  class="categoryInput" 
                  data-parsley-type="checkbox"
                  ${requireCheckboxes}
                >
                <span>${item.name}</span>
              </label>
            </li>
          `);
        });
      },
      error: function () {
        $listComponent.empty();
      },
      complete: function () {
        $('.select-category-offer').removeClass('loading');
      }
    });
  }

});